import Vue from 'vue'
import './plugins/axios'
import './plugins/tours'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import fontawsome from './plugins/fontawsome'
import i18n from './i18n'
import VueApexCharts from 'vue-apexcharts'
import Avataaars from 'vuejs-avataaars'
import * as filters from './plugins/filters'
import VueClipboard from 'vue-clipboard2'
import VueGtag from 'vue-gtag'
import VueWamp from 'vue-wamp'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import YBtn from '@/components/YBtn'
import YPagination from '@/components/YPagination'
import YPaginationCustom from '@/components/YPaginationCustom'
import YDialog from '@/components/YDialog'
import YBottomSheet from '@/components/YBottomSheet'
import YSwitch from '@/components/YSwitch'
import YCheckbox from '@/components/YCheckbox'
import YStepper from '@/components/YStepper'
import YSchedulePicker from '@/components/YSchedulePicker'
import YPhoneInput from '@/components/YPhoneInput'
import YSelect from '@/components/YSelect'
import YChip from '@/components/YChip'
import YcSelect from '@/components/connect/custom/YcSelect'
import YcTextArea from '@/components/connect/custom/YcTextArea'
import YcTextField from '@/components/connect/custom/YcTextField'
import YcCheckbox from '@/components/connect/custom/YcCheckbox'
import YcDatePicker from '@/components/connect/custom/YcDatePicker'
import YcAutocomplete from '@/components/connect/custom/YcAutocomplete'
import YcPagination from '@/components/connect/custom/YcPagination'
import YcPaginationCustom from '@/components/connect/custom/YcPaginationCustom'
import YcPhoneInput from '@/components/connect/custom/YcPhoneInput'
import { logEvent } from '@/utils'
import { VueFunnelGraph } from 'vue-funnel-graph-js'
import '@/styles/global.scss'
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')

Vue.config.productionTip = false
Vue.use(VueTour)
Vue.component('apexchart', VueApexCharts)
Vue.component('avataaars', Avataaars)
Vue.component('y-btn', YBtn)
Vue.component('y-dialog', YDialog)
Vue.component('y-bottom-sheet', YBottomSheet)
Vue.component('y-switch', YSwitch)
Vue.component('y-checkbox', YCheckbox)
Vue.component('y-pagination', YPagination)
Vue.component('y-pagination-custom', YPaginationCustom)
Vue.component('y-stepper', YStepper)
Vue.component('y-schedule-picker', YSchedulePicker)
Vue.component('y-phone-input', YPhoneInput)
Vue.component('y-select', YSelect)
Vue.component('y-chip', YChip)
Vue.component('yc-select', YcSelect)
Vue.component('yc-text-area', YcTextArea)
Vue.component('yc-text-field', YcTextField)
Vue.component('yc-checkbox', YcCheckbox)
Vue.component('yc-date-picker', YcDatePicker)
Vue.component('yc-autocomplete', YcAutocomplete)
Vue.component('yc-pagination', YcPagination)
Vue.component('yc-pagination-custom', YcPaginationCustom)
Vue.component('yc-phone-input', YcPhoneInput)
Vue.component('vue-funnel-graph', VueFunnelGraph)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueGtag, {
  config: {
    config: { id: 'UA-161700048-2' }
  }
})
Vue.use(VueWamp, {
  url: process.env.VUE_APP_WS_URL,
  realm: process.env.VUE_APP_WS_REALM
})

Vue.prototype.$subdomain = null
Vue.prototype.$isMobile = false
if (window.location.hostname.includes(`.${process.env.VUE_APP_BASE_DOMAIN}`)) {
  let subdomain = window.location.hostname.split('.')[0]
  Vue.prototype.$subdomain = subdomain
  Vue.prototype.$isLandingPage = subdomain === 'www' || subdomain === 'app'
} else {
  Vue.prototype.$subdomain = ''
  Vue.prototype.$isLandingPage = false
}

Vue.prototype.$logEvent = logEvent
Vue.prototype.$theme = 'light'
Vue.prototype.$currency = store.getters['getCompanyCurrency']

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Sentry.init({
  dsn: 'https://9e3c8d291be74abaa43f36bf98b1f947@sentry.arbatravel.com/17',
  environment: process.env.VUE_APP_ENV,
  send_default_pii: true,
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
})

new Vue({
  router,
  store,
  vuetify,
  fontawsome,
  i18n,
  render: h => h(App)
}).$mount('#app')
